export default __webpack_public_path__ + "static/media/TipIcon.d0b21c0c.svg";